import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicket = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8 10L10.6667 12.6667",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.568 7.09867C1.41737 7.24932 1.33275 7.45363 1.33275 7.66667C1.33275 7.8797 1.41737 8.08402 1.568 8.23467L3.09867 9.76533C3.24932 9.91596 3.45363 10.0006 3.66667 10.0006C3.8797 10.0006 4.08402 9.91596 4.23467 9.76533L8.254 5.746C8.38532 5.61468 8.54122 5.51051 8.7128 5.43944C8.88438 5.36837 9.06828 5.33179 9.254 5.33179C9.43972 5.33179 9.62362 5.36837 9.7952 5.43944C9.96678 5.51051 10.1227 5.61468 10.254 5.746C10.3853 5.87732 10.4895 6.03322 10.5606 6.2048C10.6316 6.37638 10.6682 6.56028 10.6682 6.746C10.6682 6.93172 10.6316 7.11562 10.5606 7.2872C10.4895 7.45878 10.3853 7.61468 10.254 7.746L6.23467 11.7653C6.08404 11.916 5.99942 12.1203 5.99942 12.3333C5.99942 12.5464 6.08404 12.7507 6.23467 12.9013L7.76533 14.432C7.91598 14.5826 8.1203 14.6673 8.33333 14.6673C8.54637 14.6673 8.75068 14.5826 8.90133 14.432L13.1447 10.1873C14.117 9.21478 14.6632 7.8958 14.6631 6.52053C14.663 5.14526 14.1165 3.82637 13.144 2.854C12.6624 2.37253 12.0908 1.99062 11.4616 1.73009C10.8325 1.46955 10.1582 1.33549 9.47719 1.33555C8.10193 1.33568 6.78304 1.88212 5.81067 2.85467L1.568 7.09867Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33333 5.33333L6 8",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgTicket;
